Ext.define('SA.MaskScrollView', {
    alias: 'widget.mask-scroll-view',
    extend: 'Ext.Component',

    initComponent() {
        this.callParent();

        this.scrollView = new SA.ScrollView();
        this.maskView = new SA.MaskView({content: this.scrollView.getEl()});
    },

    afterRender() {
        this.callParent();

        this.el.dom.append(this.maskView.getEl());
    },

    hideMask() {
        this.maskView.hideMask();
    },

    setMaxSize(maxSize) {
        this.scrollView.setMaxSize(maxSize);
    },

    setScrollContent(scrollContent) {
        this.scrollView.setContent(scrollContent);
    },

    showMask() {
        this.maskView.showMask();
    }
});